export default __webpack_public_path__ + "static/media/7_2.ce5c5bda.jpg";